<div class="prep-page">
  <div class="prep-shell">
    <header class="prep-hero">
      <div class="hero-left">
        <div class="hero-text">
          <div class="hero-topline">
            <div class="hero-icon" aria-hidden="true">
              <i class="fa-regular fa-calendar-days"></i>
              <span class="hero-pulse"></span>
            </div>
            <p class="hero-eyebrow">{{ "preparation.heroEyebrow" | t }}</p>
          </div>
          <h1 class="hero-title">{{ "preparation.heroTitle" | t }}</h1>
          <p class="hero-subtitle">{{ "preparation.heroSubtitle" | t }}</p>
          <div class="hero-meta">
            <span class="meta-chip">
              <i class="fa-solid fa-clipboard-list"></i>
              {{ "preparation.metaStepByStep" | t }}
            </span>
            <span class="meta-chip">
              <i class="fa-solid fa-lock"></i>
              {{ "preparation.metaSecureData" | t }}
            </span>
          </div>
        </div>
      </div>
    </header>

    <div class="prep-grid">
      <section class="prep-panel">
        <div class="panel-header">
          <div>
            <h2 class="panel-title">{{ "preparation.panelTitle" | t }}</h2>
            <p class="panel-subtitle">{{ "preparation.panelSubtitle" | t }}</p>
          </div>
        </div>

        <form
          id="preparationForm"
          class="prep-form"
          [formGroup]="preparationForm"
          (ngSubmit)="savePreparation($event)"
          autocomplete="off"
        >
          <div class="block">
            <div class="block-header">
              <span class="block-number">01</span>
              <h3 class="block-title">{{ "preparation.personalInfoTitle" | t }}</h3>
            </div>

            <div class="input-group">
              <label for="inputTc" class="input-label required">{{
                "preparation.tcLabel" | t
              }}</label>
              <div class="input-wrap">
                <i class="fa-solid fa-id-card"></i>
                <input
                  type="text"
                  id="inputTc"
                  class="input-field"
                  [placeholder]="'preparation.tcPlaceholder' | t"
                  formControlName="tc"
                  [attr.inputmode]="isTurkishIdentityMode ? 'numeric' : null"
                  [attr.pattern]="isTurkishIdentityMode ? '\\d*' : null"
                  [attr.maxlength]="isTurkishIdentityMode ? 11 : 64"
                  (input)="onTcInput($any($event.target).value)"
                  (blur)="onIdentityBlur()"
                />
              </div>
              <div class="input-error" *ngIf="isControlInvalid('tc')">
                <span *ngIf="preparationForm.get('tc')?.errors?.['required']">
                  {{ "preparation.tcRequired" | t }}
                </span>
                <span
                  *ngIf="
                    isTurkishIdentityMode &&
                    preparationForm.get('tc')?.errors?.['tcKimlikInvalid']
                  "
                >
                  {{ "preparation.tcInvalid" | t }}
                </span>
              </div>
            </div>

            <div class="form-row">
              <div class="input-group">
                <label for="inputName" class="input-label required">{{
                  "preparation.nameLabel" | t
                }}</label>
                <div class="input-wrap has-select">
                  <i class="fa-solid fa-user"></i>
                  <input
                    type="text"
                    id="inputName"
                    class="input-field"
                    [placeholder]="'preparation.namePlaceholder' | t"
                    [(ngModel)]="formState.name"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="isIdentityInputDisabled"
                    (keydown)="onNameKeyDown($event)"
                    (input)="onNameInput($any($event.target).value)"
                    (blur)="markTouched('name')"
                  />
                </div>
                <div
                  class="input-error"
                  *ngIf="isFieldTouched('name') && isRequiredMissing('name')"
                >
                  {{ "common.requiredField" | t }}
                </div>
              </div>
              <div class="input-group">
                <label for="inputLastName" class="input-label required">{{
                  "preparation.lastNameLabel" | t
                }}</label>
                <div class="input-wrap has-select">
                  <i class="fa-solid fa-user-tag"></i>
                  <input
                    type="text"
                    id="inputLastName"
                    class="input-field"
                    [placeholder]="'preparation.lastNamePlaceholder' | t"
                    [(ngModel)]="formState.lastName"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="isIdentityInputDisabled"
                    (keydown)="onNameKeyDown($event)"
                    (input)="onLastNameInput($any($event.target).value)"
                    (blur)="markTouched('lastName')"
                  />
                </div>
                <div
                  class="input-error"
                  *ngIf="
                    isFieldTouched('lastName') && isRequiredMissing('lastName')
                  "
                >
                  {{ "common.requiredField" | t }}
                </div>
              </div>
            </div>

            <div class="input-group">
              <label for="inputDob" class="input-label required">{{
                "preparation.birthDateLabel" | t
              }}</label>
              <div class="input-wrap">
                <i class="fa-solid fa-cake-candles"></i>
                <input
                  type="text"
                  id="inputDob"
                  class="input-field"
                  [placeholder]="'preparation.birthDatePlaceholder' | t"
                  maxlength="10"
                  [(ngModel)]="formState.birthDate"
                  [ngModelOptions]="{ standalone: true }"
                  inputmode="numeric"
                  pattern="\\d*"
                  (input)="onDateInputChange($any($event.target).value)"
                  (blur)="markTouched('birthDate')"
                />
              </div>
              <div
                class="input-error"
                *ngIf="
                  isFieldTouched('birthDate') && isRequiredMissing('birthDate')
                "
              >
                {{ "common.requiredField" | t }}
              </div>
            </div>

            <div class="input-group">
              <label class="input-label required">{{
                "preparation.genderLabel" | t
              }}</label>
              <div class="choice-grid">
                <div class="choice-card">
                  <input
                    type="radio"
                    id="mrOption"
                    name="gender"
                    value="2"
                    [(ngModel)]="formState.gender"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="onGenderChange(formState.gender)"
                    (blur)="markTouched('gender')"
                  />
                  <label for="mrOption">
                    <i class="fa-solid fa-person"></i>
                    <span>{{ "preparation.male" | t }}</span>
                    <div class="choice-dot"></div>
                  </label>
                </div>
                <div class="choice-card">
                  <input
                    type="radio"
                    id="msOption"
                    name="gender"
                    value="3"
                    [(ngModel)]="formState.gender"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="onGenderChange(formState.gender)"
                    (blur)="markTouched('gender')"
                  />
                  <label for="msOption">
                    <i class="fa-solid fa-person-dress"></i>
                    <span>{{ "preparation.female" | t }}</span>
                    <div class="choice-dot"></div>
                  </label>
                </div>
              </div>
              <div
                class="input-error"
                *ngIf="isFieldTouched('gender') && isRequiredMissing('gender')"
              >
                {{ "common.requiredField" | t }}
              </div>
            </div>

            <div class="form-row">
              <div class="input-group">
                <label for="inputMobilePhone" class="input-label required">{{
                  "preparation.phoneLabel" | t
                }}</label>
                <div class="input-wrap">
                  <i class="fa-solid fa-mobile-screen-button"></i>
                  <input
                    type="tel"
                    id="inputMobilePhone"
                    class="input-field"
                    [placeholder]="'preparation.phonePlaceholder' | t"
                    [(ngModel)]="formState.phone"
                    [ngModelOptions]="{ standalone: true }"
                    inputmode="numeric"
                    pattern="\\d*"
                    maxlength="13"
                    (keydown)="onPhoneKeyDown($event)"
                    (input)="onPhoneInputChange($any($event.target).value)"
                    (blur)="markTouched('phone')"
                  />
                </div>
                <div
                  class="input-error"
                  *ngIf="isFieldTouched('phone') && isRequiredMissing('phone')"
                >
                  {{ "common.requiredField" | t }}
                </div>
              </div>
              <div class="input-group">
                <label for="inputEmail" class="input-label required">{{
                  "preparation.emailLabel" | t
                }}</label>
                <div class="input-wrap">
                  <i class="fa-solid fa-envelope"></i>
                  <input
                    type="email"
                    id="inputEmail"
                    class="input-field"
                    [placeholder]="'preparation.emailPlaceholder' | t"
                    [(ngModel)]="formState.email"
                    [ngModelOptions]="{ standalone: true }"
                    (keydown)="onEmailKeyDown($event)"
                    (input)="onEmailInput($any($event.target).value)"
                    (blur)="markTouched('email')"
                  />
                </div>
                <div
                  class="input-error"
                  *ngIf="isFieldTouched('email') && isRequiredMissing('email')"
                >
                  {{ "common.requiredField" | t }}
                </div>
                <div
                  class="input-error"
                  *ngIf="
                    isFieldTouched('email') &&
                    !isRequiredMissing('email') &&
                    !!preparationForm.get('email')?.errors?.['email']
                  "
                >
                  {{ "preparation.emailInvalid" | t }}
                </div>
              </div>
            </div>
          </div>

          <div class="block">
            <div class="block-header">
              <span class="block-number">02</span>
              <h3 class="block-title">{{ "preparation.addressInfoTitle" | t }}</h3>
            </div>

            <div class="form-row">
              <div class="input-group">
                <label for="inputCity" class="input-label required">{{
                  "preparation.cityLabel" | t
                }}</label>
                <div class="input-wrap select-wrap has-ng-select">
                  <i class="fa-solid fa-city"></i>
                  <ng-select
                    class="ng-select-prep"
                    [items]="cities"
                    bindLabel="name"
                    bindValue="id"
                    [(ngModel)]="formState.city"
                    [ngModelOptions]="{ standalone: true }"
                    [clearable]="false"
                    [notFoundText]="'common.noRecordsFound' | t"
                    [placeholder]="'preparation.cityPlaceholder' | t"
                    (change)="onCityChange(formState.city)"
                    (blur)="markTouched('city')"
                  ></ng-select>
                </div>
                <div
                  class="input-error"
                  *ngIf="isFieldTouched('city') && isRequiredMissing('city')"
                >
                  {{ "common.requiredField" | t }}
                </div>
              </div>
              <div class="input-group">
                <label for="inputDistrict" class="input-label required">{{
                  "preparation.districtLabel" | t
                }}</label>
                <div class="input-wrap select-wrap has-ng-select">
                  <i class="fa-solid fa-map-pin"></i>
                  <ng-select
                    class="ng-select-prep"
                    [items]="districts"
                    bindLabel="name"
                    bindValue="id"
                    [(ngModel)]="formState.district"
                    [ngModelOptions]="{ standalone: true }"
                    [clearable]="false"
                    [disabled]="!formState.city"
                    [notFoundText]="'common.noRecordsFound' | t"
                    [placeholder]="'preparation.districtPlaceholder' | t"
                    (blur)="markTouched('district')"
                  ></ng-select>
                </div>
                <div
                  class="input-error"
                  *ngIf="
                    isFieldTouched('district') && isRequiredMissing('district')
                  "
                >
                  {{ "common.requiredField" | t }}
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="input-group">
                <label for="inputNeighborhood" class="input-label required">{{
                  "preparation.neighborhoodLabel" | t
                }}</label>
                <div class="input-wrap">
                  <i class="fa-solid fa-map-location-dot"></i>
                  <input
                    type="text"
                    id="inputNeighborhood"
                    class="input-field"
                    [placeholder]="'preparation.neighborhoodPlaceholder' | t"
                    [(ngModel)]="formState.neighborhood"
                    [ngModelOptions]="{ standalone: true }"
                    (blur)="markTouched('neighborhood')"
                  />
                </div>
                <div
                  class="input-error"
                  *ngIf="
                    isFieldTouched('neighborhood') &&
                    isRequiredMissing('neighborhood')
                  "
                >
                  {{ "common.requiredField" | t }}
                </div>
              </div>
              <div class="input-group">
                <label for="inputStreet" class="input-label required">{{
                  "preparation.streetLabel" | t
                }}</label>
                <div class="input-wrap">
                  <i class="fa-solid fa-road"></i>
                  <input
                    type="text"
                    id="inputStreet"
                    class="input-field"
                    [placeholder]="'preparation.streetPlaceholder' | t"
                    [(ngModel)]="formState.street"
                    [ngModelOptions]="{ standalone: true }"
                    (blur)="markTouched('street')"
                  />
                </div>
                <div
                  class="input-error"
                  *ngIf="
                    isFieldTouched('street') && isRequiredMissing('street')
                  "
                >
                  {{ "common.requiredField" | t }}
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="input-group">
                <label for="inputBuildingNo" class="input-label required">{{
                  "preparation.buildingNoLabel" | t
                }}</label>
                <div class="input-wrap">
                  <i class="fa-solid fa-building"></i>
                  <input
                    type="text"
                    id="inputBuildingNo"
                    class="input-field"
                    [placeholder]="'preparation.buildingNoPlaceholder' | t"
                    [(ngModel)]="formState.buildingNo"
                    [ngModelOptions]="{ standalone: true }"
                    (blur)="markTouched('buildingNo')"
                  />
                </div>
                <div
                  class="input-error"
                  *ngIf="
                    isFieldTouched('buildingNo') &&
                    isRequiredMissing('buildingNo')
                  "
                >
                  {{ "common.requiredField" | t }}
                </div>
              </div>
              <div class="input-group">
                <label for="inputApartmentNo" class="input-label required">{{
                  "preparation.apartmentNoLabel" | t
                }}</label>
                <div class="input-wrap">
                  <i class="fa-solid fa-door-closed"></i>
                  <input
                    type="text"
                    id="inputApartmentNo"
                    class="input-field"
                    [placeholder]="'preparation.apartmentNoPlaceholder' | t"
                    [(ngModel)]="formState.apartmentNo"
                    [ngModelOptions]="{ standalone: true }"
                    (blur)="markTouched('apartmentNo')"
                  />
                </div>
                <div
                  class="input-error"
                  *ngIf="
                    isFieldTouched('apartmentNo') &&
                    isRequiredMissing('apartmentNo')
                  "
                >
                  {{ "common.requiredField" | t }}
                </div>
              </div>
            </div>
          </div>

          <div class="actions">
            <button
              type="button"
              class="primary-btn"
              (click)="goToCreateAppointment()"
              [disabled]="isSubmitDisabled"
            >
              <span>{{ "preparation.nextButton" | t }}</span>
              <i class="fa-solid fa-circle-check"></i>
              <div class="btn-glow"></div>
            </button>
          </div>
        </form>
      </section>

      <aside class="prep-aside">
        <div class="aside-card checklist-card">
          <h3>{{ "preparation.checklistTitle" | t }}</h3>
          <p>{{ "preparation.checklistSubtitle" | t }}</p>
          <ul class="checklist">
            <li
              *ngFor="let item of completedChecklist"
              class="checklist-item done"
            >
              <span class="check-icon">
                <i class="fa-solid fa-check"></i>
              </span>
              <span class="check-text">{{ item.label }}</span>
            </li>
            <li *ngIf="completedChecklist.length === 0" class="checklist-empty">
              {{ "preparation.checklistEmpty" | t }}
            </li>
          </ul>
        </div>
      </aside>
    </div>
  </div>

  <div class="bg-orb orb-1"></div>
  <div class="bg-orb orb-2"></div>
  <div class="bg-orb orb-3"></div>
</div>
